import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { userManager } from "@/auth/userManager";

/**
 * Replaces doh_web_frontend's 14 separate `createApi` slices. Those
 * existed mainly because the app had accreted TWO different hardcoded
 * backend hosts (27 calls to doh-backend.onrender.com, 21 to
 * http://localhost:5000, one hardcoded inside a "render" slice) — see
 * the plan's "Two hardcoded backend hosts" fix. With one real base URL
 * there's no reason for 14 reducers; this is one `createApi` with
 * endpoints injected per domain file for organization.
 *
 * `prepareHeaders` attaches the Asgardeo access token to every request.
 * The original sent it on exactly 1 of 55 calls (campaignsApi.ts's
 * approval mutation) — everything else hit the backend unauthenticated.
 * See the plan's "Backend called unauthenticated" fix.
 */
const API_BASE_URL = import.meta.env.VITE_API_BASE_URL as string;

export const api = createApi({
  reducerPath: "api",
  baseQuery: fetchBaseQuery({
    baseUrl: `${API_BASE_URL}/api`,
    prepareHeaders: async (headers) => {
      const user = await userManager.getUser();
      if (user?.access_token) {
        headers.set("Authorization", `Bearer ${user.access_token}`);
      }
      return headers;
    },
  }),
  tagTypes: [
    "Appointment", "BloodBankHome", "BloodDonation", "BloodEquipment", "BloodTest",
    "Blood", "Campaign", "DonationForm", "DonationReports", "Donors", "HealthVitals",
    "Inventory", "MedicalEstablishments", "Requests", "Slots", "Users", "Emergencies", "Home",
  ],
  endpoints: () => ({}),
});
